var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentAddPageOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18h9v2H4a1.93 1.93 0 01-1.413-.587A1.928 1.928 0 012 18V4c0-.55.196-1.021.587-1.413A1.928 1.928 0 014 2h14c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v9h-2V4H4v14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16h7v-2H6v2zm10-4H6v-2h10v2zM6 8h10V6H6v2zm14 15h-2v-3h-3v-2h3v-3h2v3h3v2h-3v3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentAddPageOutline);
export default __webpack_public_path__ + "923c615965127c73bc3627005adb414e.svg";
export { ForwardRef as ReactComponent };